import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const SuccessIcon = (props) => {
  return (
    <svg version="1.1"  height="20px" width="20px"
	    viewBox="0 0 50 50" style={{ "enableBackground":"new 0 0 50 50"}} >
      <circle style={{"fill":"#25AE88"}} cx="25" cy="25" r="25"/>
      <polyline 
      style={{fill:"none",stroke:"#FFFFFF", "strokeWidth":5,
      "strokeLinecap":"round", "strokeLinejoin":"round", "strokeMiterlimit":10}} 
      points="
	    38,15 22,33 12,25 "/>
    </svg>
  );
};

export default SuccessIcon;
